module.exports = "<input class=\"take-action\" [checked]=\"params?.data.take\" type=\"checkbox\" (change)=\"onChange($event)\"/>"